import { createCommonjsModule } from '../../_virtual/_commonjsHelpers.js';
import reactIs from './node_modules/react-is/index.js';
import factoryWithTypeCheckers from './factoryWithTypeCheckers.js';
import factoryWithThrowingShims from './factoryWithThrowingShims.js';

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

export { propTypes as __moduleExports, propTypes as default };
//# sourceMappingURL=index.js.map
